<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	import { postReq } from '../../../services/http';
	//Stores
	import { user_data } from 'src/stores/account/user';
import { wearables_connected } from 'src/stores/session/native-bridge';
	//Design system components
	import { ButtonV2, Stack, Text, toast } from '@Shelly/shelly-design-system';
	import { init_wearables_android } from '../../../services/native_container_requests_android';
	import { capFirstChar } from 'src/helpers/utilities';

	$: disabled = $wearables_connected == 0 || $user_data?.installer;

	const handleWearablesSettings = () => {
		console.log('Open Android wearables settings');
		init_wearables_android();
	};
</script>

<Stack direction="column" directionMobile="row" align="between" alignMobile="none" gap="m">
	<div>
		<Text styleType="body-small" class="text-color-muted">
			{$format('wearables_descriptions', {
				default: 'Currently connected wearable devices:',
			}) +
				' ' +
				$wearables_connected}
		</Text>
	</div>

	<ButtonV2
		size="m"
		variant="primary"
		class="width-md-auto width-sm-full"
		{disabled}
		on:click={handleWearablesSettings}
	>
		{capFirstChar($format('add_devices', { default: 'add devices' }))}
	</ButtonV2>
</Stack>
